import React from 'react';
import PropTypes from 'prop-types';
import FlightInfo from '../../../../components/flightInfo/FlightInfo';
import { Col, Row } from 'antd';

import './flightChangeSelectionContainer.css';

const I18n = require('i18n-react').default;

const propTypes = {
  originFlight: PropTypes.object,
  destinyFlight: PropTypes.object,
  onChangeOrigin: PropTypes.func,
  onChangeDestiny: PropTypes.func,
  isSelectedOrigin: PropTypes.bool,
  isSelectedDestiny: PropTypes.bool
};

class FlightChangeSelectionContainer extends React.Component {
  render() {
    return (
      <div>
        <Row>
          <Col className="ChangeFlight__subtitle1">
            <h1>{I18n.translate('label.changeFlight')}</h1>
          </Col>
        </Row>
        <Row className="margin-eight-top-8">
          <Col>
            <FlightInfo
              name="departureFlight"
              className="FlightInfo__departure"
              isDepartureFlight={true}
              flight={this.props.originFlight}
              selectable
              onChangeCheckbox={this.props.onChangeOrigin}
              isSelected={this.props.isSelectedOrigin}
            />
          </Col>
        </Row>

        {this.props.destinyFlight && (
          <Row className="margin-eight-top-8">
            <Col>
              <FlightInfo
                name="departureFlight"
                className="FlightInfo__departure"
                isDepartureFlight={false}
                flight={this.props.destinyFlight}
                selectable
                onChangeCheckbox={this.props.onChangeDestiny}
                isSelected={this.props.isSelectedDestiny}
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

FlightChangeSelectionContainer.propTypes = propTypes;

export default FlightChangeSelectionContainer;



// WEBPACK FOOTER //
// ./src/page/flightChangeSelection/components/FlightChangeSelectionContainer/index.jsx